export default __webpack_public_path__ + "static/media/game-icon.6fcf4e93.svg";